<template>
    <form-wrapper class="intake-social" @submit="handleFormSubmission(data)">
        <intake-form-section :title="$t('forms.intake.social_family.sections.smoking')">
            <form-row>
                <form-cell>
                    <tabs-field
                        :options="smokingOptions"
                        :formData="data"
                        valuePath="smoking"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <intake-form-section :title="$t('forms.intake.social_family.sections.alcohol')">
            <form-row>
                <form-cell>
                    <tabs-field
                        :options="alcoholOptions"
                        :formData="data"
                        valuePath="alcohol"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <intake-form-section :title="$t('forms.intake.social_family.sections.drug_use')">
            <form-row>
                <form-cell>
                    <tabs-field
                        :options="drugUseOptions"
                        :formData="data"
                        valuePath="drugUse"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <intake-form-section :title="$t('forms.intake.social_family.sections.family_history')">
            <form-row>
                <form-cell>
                    <tabs-field
                        :label="$t('forms.intake.social_family.fields.family_history.label')"
                        :options="familyHistoryOptions"
                        :formData="data"
                        valuePath="familyHistory"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const SMOKING_OPTIONS = ['never', 'former', 'current', 'unknown']
    const ALCOHOL_OPTIONS = ['none', 'occasional', 'regular', 'former', 'declined']
    const DRUG_USE_OPTIONS = ['no', 'yes', 'former', 'declined']
    const FAMILY_HISTORY_OPTIONS = ['none_known', 'has_history', 'unknown']

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            return {
                data: {
                    smoking: undefined,
                    alcohol: undefined,
                    drugUse: undefined,
                    familyHistory: undefined,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            smokingOptions() {
                return SMOKING_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.social_family.fields.smoking.options.${value}`),
                    value,
                }))
            },

            alcoholOptions() {
                return ALCOHOL_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.social_family.fields.alcohol.options.${value}`),
                    value,
                }))
            },

            drugUseOptions() {
                return DRUG_USE_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.social_family.fields.drug_use.options.${value}`),
                    value,
                }))
            },

            familyHistoryOptions() {
                return FAMILY_HISTORY_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.social_family.fields.family_history.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
